import { IBaseEvent, IEvent, ClusterRelatedArticle, ClusterSecondaryRef, EventCluster, FeedCluster } from "interfaces";
import moment from "moment";
import UserStore from "stores/UserStore";

export const getEventCountries = (
    event: IBaseEvent,
    includeMentionedCountries: boolean
) => {
    return includeMentionedCountries ? event.countries : event.focus_countries;
};

export const isEventNew = (event: IBaseEvent) => {
    return moment().diff(event.time, 'days') <= 7;
};

export const canDeleteScore = (event: IBaseEvent, userStore: typeof UserStore) => {
    const { canDelete, canEditOld } = userStore.uscoresPermissions;
    return canDelete && event && (isEventNew(event) || canEditOld);
};

export const canScore = (event: IBaseEvent, userStore: typeof UserStore) => {
    const { canScore, canEditOld } = userStore.uscoresPermissions;
    return canScore && event && (isEventNew(event) || canEditOld);
};

export const canEditScore = (event: IBaseEvent, userStore: typeof UserStore) => {
    const { canEdit, canEditOld } = userStore.uscoresPermissions;
    return canEdit && event && (isEventNew(event) || canEditOld);
};

export const isSecondaryArticle = (
    event: IEvent
): event is IEvent & { cluster: ClusterSecondaryRef } => {
    return Boolean(
        event?.cluster &&
            'representative_event_id' in event.cluster &&
            event.cluster.representative_headline &&
            event.cluster.representative_event_id !== event.id
    );
};

export const getClusterArticles = (
    event: IEvent
): ClusterRelatedArticle[] | undefined => {
    return event?.cluster && 'articles' in event.cluster
        ? event.cluster.articles
        : undefined;
};

export const getFeedCluster = (
    cluster?: EventCluster
): FeedCluster | undefined => {
    return cluster && 'article_count' in cluster ? cluster : undefined;
};
